angular.module('app.dateDirective', [])
  .directive('date', [
    'DATE_FORMAT',
    /**
     * @param DATE_FORMAT
     * @returns {{
     * restrict: string,
     * link: (function(*, *, {parseFormat: string, date: string, format: string, showDate: string, showTime: string}))
     * }}
     */
    function (DATE_FORMAT) {
      'use strict';

      return {
        restrict: 'A',
        link: (scope, elm, attrs) => {
          let date, format, show_date, show_time;
          if (attrs.date) {
            if (attrs.parseFormat) {
              date = moment(attrs.date, attrs.parseFormat);
            } else {
              date = moment(new Date(attrs.date));
            }
            if (attrs.format) {
              format = attrs.format;
            } else {
              if (typeof attrs.showDate !== 'undefined') {
                show_date = parseBoolean(attrs.showDate);
              } else {
                show_date = true;
              }
              if (typeof attrs.showTime !== 'undefined') {
                show_time = parseBoolean(attrs.showTime);
              } else {
                show_time = true;
              }
              format = '';
              if (show_date) {
                format += DATE_FORMAT.moment.date;
              }
              if (show_time) {
                if (show_date) {
                  format += ' ';
                }
                format += DATE_FORMAT.moment.time;
              }
            }
            return elm.text(date.format(format));
          }
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/date/dateDirective.js